import { createSlice } from '@reduxjs/toolkit'

const filtersSlice = createSlice({
  name: 'filters',
  initialState: {},
  reducers: {
    setFilter: (state, action) => {
      return {
        ...state,
        ...action.payload,
      }
    },
    clearFiltersButKeepSort: (state: {
      sort?: [{ fields: string; dir: string }]
      searchTerm?: string
    }) => {
      const nextState: { sort?: [{ fields: string; dir: string }]; searchTerm?: string } = {}

      if (state.sort) {
        nextState.sort = state.sort
      }

      if (state.searchTerm) {
        nextState.searchTerm = state.searchTerm
      }

      return nextState
    },
    setSort: (state, action) => {
      const { field, dir } = action.payload
      return {
        ...state,
        sort: [
          {
            field,
            dir,
          },
        ],
      }
    },
    clearSort: (state: { sort?: [{ fiels: string; dir: string }] }) => {
      const { sort, ...rest } = state
      return rest
    },
    setSearchTerm: (state, action) => {
      return {
        ...state,
        searchTerm: action.payload,
      }
    },
    clearSearchTerm: state => {
      const { searchTerm, ...rest }: { searchTerm?: string } = state
      return rest
    },
  },
})

export const {
  setFilter,
  clearFiltersButKeepSort,
  clearSort,
  setSort,
  setSearchTerm,
  clearSearchTerm,
} = filtersSlice.actions
export default filtersSlice.reducer
